import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MonNumberPipe } from '@client/ng2/core/locale/pipes/mon-number.pipe';

@Component({
    selector: 'table-score-chart',
    standalone: false,
    template: `
        <div class="table-score-chart " [ngClass]="{'big-score-chart': bigChart == true}">
            <div class="mon-doughnut-chart inline-block"
                 [ngClass]="getDoughnutClass()">
                <div class="slices mon-doughnut-slice-one"></div>
                <div class="slices mon-doughnut-slice-two"></div>
                <div class="chart-center">
                  <span>{{getPerformanceScore()}}</span>
                </div>
            </div>
        </div>
    `,
})
export class TableScoreChartComponent implements OnInit {
    @Input() performanceScore: any;
    @Input() bigChart: any;
    @Output() monActionEvent = new EventEmitter<any>();

    constructor (private monNumberPipe: MonNumberPipe) {}

    ngOnInit (): void {
        this.bigChart = Boolean(this.bigChart);
    }

    getDoughnutClass (): string {
        return 'chart-point-' + this.getSliceSize();
    }

    getSliceSize (): string {
        if (typeof this.performanceScore === 'number') {
            return this.monNumberPipe.transform(100 * this.performanceScore, '0');
        }
        return '0';
    }

    getPerformanceScore (): string {
        if (typeof this.performanceScore === 'number') {
            return this.monNumberPipe.transform(this.performanceScore * 100, '0');
        }
        return 'N/A';
    }
}
